import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import Dashboard from "@/pages/Dashboard";
import LifeMartDashboard from "@/pages/LifeMartDashboard";
import AuthGate from "@/components/AuthGate";
import TrackGate from "@/components/TrackGate";
import { useLifeMart } from "@/hooks/useLifeMart";
import { useSearchParams } from "@/lib/router-compat";

// Routes /dashboard to the co-branded LifeMart variant for verified members,
// or the classic Dashboard otherwise. Members can opt out via ?classic=1.
// (ported from App.tsx's DashboardRouter)
const DashboardRouter = () => {
  const { isLifeMartMember, loading } = useLifeMart();
  const [params] = useSearchParams();
  const classic = params.get("classic") === "1";
  if (loading) return null;
  if (isLifeMartMember && !classic) return <LifeMartDashboard />;
  return <Dashboard />;
};

export const Route = createFileRoute("/dashboard")({
  head: () => seoHead("/dashboard"),
  component: () => (
    <AuthGate><TrackGate><DashboardRouter /></TrackGate></AuthGate>
  ),
});